import { axiosInstance } from "./AxiosDefaults";
import { virtualReproWarehouseRoute } from "../constants/ApiRoutes";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getVirtualReproWarehouse = () => {
  return axiosInstance.get<ApiResponse<any>>(virtualReproWarehouseRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createVirtualReproWarehouse = (payload: any) => {
  return axiosInstance.post<ApiResponse<any>>(
    virtualReproWarehouseRoute,
    payload,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    },
  );
};

export const updateVirtualReproWarehouse = (payload: any) => {
  return axiosInstance.put<ApiResponse<any>>(
    `${virtualReproWarehouseRoute}`,
    payload,
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    },
  );
};
